import { render, staticRenderFns } from "./BookingAssistant13.vue?vue&type=template&id=9d574d10&scoped=true&lang=pug&"
import script from "./BookingAssistant13.vue?vue&type=script&lang=ts&"
export * from "./BookingAssistant13.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d574d10",
  null
  
)

export default component.exports